import COLORS from 'utils/constants/colors';

export const RISK_CONSEQUENCES = {
  INSIGNIFICANT: { id: 'INSIGNIFICANT', name: 'Insignificant' },
  MINOR: { id: 'MINOR', name: 'Minor' },
  MODERATE: { id: 'MODERATE', name: 'Moderate' },
  MAJOR: { id: 'MAJOR', name: 'Major' },
  SEVERE: { id: 'SEVERE', name: 'Severe' },
};

export const RISK_LIKELIHOOD = {
  RARE: { id: 'RARE', name: 'Rare' },
  UNLIKELY: { id: 'UNLIKELY', name: 'Unlikely' },
  POSSIBLE: { id: 'POSSIBLE', name: 'Possible' },
  LIKELY: { id: 'LIKELY', name: 'Likely' },
  ALMOST_CERTAIN: { id: 'ALMOST_CERTAIN', name: 'Almost Certain' },
};

export const RISK_LEVEL = {
  LOW: { id: 'LOW', name: 'Low' },
  MEDIUM: { id: 'MEDIUM', name: 'Medium' },
  HIGH: { id: 'HIGH', name: 'High' },
  EXTREME: { id: 'EXTREME', name: 'Extreme' },
};

export const riskColors = {
  [RISK_LEVEL.EXTREME.id]: COLORS.RED,
  [RISK_CONSEQUENCES.SEVERE.id]: COLORS.RED,
  [RISK_LEVEL.HIGH.id]: COLORS.ORANGE,
  [RISK_CONSEQUENCES.MAJOR.id]: COLORS.ORANGE,
  [RISK_LEVEL.MEDIUM.id]: COLORS.YELLOW,
  [RISK_CONSEQUENCES.MODERATE.id]: COLORS.YELLOW,
  [RISK_LEVEL.LOW.id]: COLORS.GREEN,
  [RISK_CONSEQUENCES.MINOR.id]: COLORS.GREEN,
  [RISK_CONSEQUENCES.INSIGNIFICANT.id]: COLORS.DARK_GREY,
  // Other region colors
  // SITE: '#00C8AF',
  SITE: COLORS.DARK_GREY_02,
  NEWS: COLORS.RED_01,
  REGION: COLORS.BLUE_01,
  OTHERS: COLORS.BLUE_01,
};

export const RISK_CONSEQUENCE_OPTIONS = [
  RISK_CONSEQUENCES.INSIGNIFICANT,
  RISK_CONSEQUENCES.MINOR,
  RISK_CONSEQUENCES.MODERATE,
  RISK_CONSEQUENCES.MAJOR,
  RISK_CONSEQUENCES.SEVERE,
];

export const RISK_LIKELIHOOD_OPTIONS = [
  RISK_LIKELIHOOD.RARE,
  RISK_LIKELIHOOD.UNLIKELY,
  RISK_LIKELIHOOD.POSSIBLE,
  RISK_LIKELIHOOD.LIKELY,
  RISK_LIKELIHOOD.ALMOST_CERTAIN,
];

export const RISK_LEVEL_OPTIONS = [
  RISK_LEVEL.LOW,
  RISK_LEVEL.MEDIUM,
  RISK_LEVEL.HIGH,
  RISK_LEVEL.EXTREME,
];

export const riskMatrix = {
  [RISK_LIKELIHOOD.RARE.id]: {
    [RISK_CONSEQUENCES.INSIGNIFICANT.id]: RISK_LEVEL.LOW.name,
    [RISK_CONSEQUENCES.MINOR.id]: RISK_LEVEL.LOW.name,
    [RISK_CONSEQUENCES.MODERATE.id]: RISK_LEVEL.LOW.name,
    [RISK_CONSEQUENCES.MAJOR.id]: RISK_LEVEL.MEDIUM.name,
    [RISK_CONSEQUENCES.SEVERE.id]: RISK_LEVEL.MEDIUM.name,
  },
  [RISK_LIKELIHOOD.UNLIKELY.id]: {
    [RISK_CONSEQUENCES.INSIGNIFICANT.id]: RISK_LEVEL.LOW.name,
    [RISK_CONSEQUENCES.MINOR.id]: RISK_LEVEL.LOW.name,
    [RISK_CONSEQUENCES.MODERATE.id]: RISK_LEVEL.MEDIUM.name,
    [RISK_CONSEQUENCES.MAJOR.id]: RISK_LEVEL.MEDIUM.name,
    [RISK_CONSEQUENCES.SEVERE.id]: RISK_LEVEL.HIGH.name,
  },
  [RISK_LIKELIHOOD.POSSIBLE.id]: {
    [RISK_CONSEQUENCES.INSIGNIFICANT.id]: RISK_LEVEL.LOW.name,
    [RISK_CONSEQUENCES.MINOR.id]: RISK_LEVEL.MEDIUM.name,
    [RISK_CONSEQUENCES.MODERATE.id]: RISK_LEVEL.MEDIUM.name,
    [RISK_CONSEQUENCES.MAJOR.id]: RISK_LEVEL.HIGH.name,
    [RISK_CONSEQUENCES.SEVERE.id]: RISK_LEVEL.HIGH.name,
  },
  [RISK_LIKELIHOOD.LIKELY.id]: {
    [RISK_CONSEQUENCES.INSIGNIFICANT.id]: RISK_LEVEL.MEDIUM.name,
    [RISK_CONSEQUENCES.MINOR.id]: RISK_LEVEL.MEDIUM.name,
    [RISK_CONSEQUENCES.MODERATE.id]: RISK_LEVEL.MEDIUM.name,
    [RISK_CONSEQUENCES.MAJOR.id]: RISK_LEVEL.HIGH.name,
    [RISK_CONSEQUENCES.SEVERE.id]: RISK_LEVEL.EXTREME.name,
  },
  [RISK_LIKELIHOOD.ALMOST_CERTAIN.id]: {
    [RISK_CONSEQUENCES.INSIGNIFICANT.id]: RISK_LEVEL.MEDIUM.name,
    [RISK_CONSEQUENCES.MINOR.id]: RISK_LEVEL.MEDIUM.name,
    [RISK_CONSEQUENCES.MODERATE.id]: RISK_LEVEL.HIGH.name,
    [RISK_CONSEQUENCES.MAJOR.id]: RISK_LEVEL.HIGH.name,
    [RISK_CONSEQUENCES.SEVERE.id]: RISK_LEVEL.EXTREME.name,
  },
};
